import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
	useHistory,
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
	Link,
} from "react-router-dom";
import { Button } from "reactstrap";
import "./App.css";
import { logPageView } from "utilities/gaTracker";
import { useAuth } from "contexts/auth-context";
import NavBar from "components/NavBar";
import Home from "./pages/Home";
import Login from "./pages/User/Login";
import SignUp from "./pages/User/SignUp";
import Education from "./pages/Education";
import News from "./pages/News";
import EventUpload from "./pages/EventUpload";
import Jobs from "./pages/Jobs";
import JobApplication from "./pages/JobApplication";
import About from "./pages/About";
import Alumni from "./pages/Alumni";
import Events from "./pages/Events";
import COVID from "./pages/COVID/COVID-19";
import COVIDA from "./pages/COVID/COVID_FAQs";
import COVIDQ from "./pages/COVID/COVID_Question";
import COVIDAnswer from "./pages/COVID/AnswerQuestion";
import AppBox from "./pages/Software";
import Publications from "./pages/Publications";

function Footer() {
	const { user, logout } = useAuth();

	return (
		<footer className="footer">
			<p>
				&copy; {new Date().getFullYear()} Maintained by{" "}
				<a
					href="http://city.umd.edu"
					style={{ color: "#818182", textDecoration: "none" }}
				>
					The Center for Sustainability
				</a>
				{/* <span>
					{" "}
					Developed by{" "}
					<a
						href="http://mattise.dev"
						style={{ color: "#818182", textDecoration: "none" }}
					>
						Nicholas Mattise
					</a>
				</span> */}
				<span>
					{"	|	"}
					{user ? (
						<Button size="sm" color="link" onClick={logout}>
							Logout
						</Button>
					) : (
						<Button size="sm" color="link" tag={Link} to="/user/login">
							Login
						</Button>
					)}
				</span>
			</p>
		</footer>
	);
}
const redirects = [{ from: "/app-box", to: "/software" }];
function Routes() {
	const history = useHistory();
	useEffect(() => {
		logPageView(history);
	}, [history]);
	return (
		<React.Fragment>
			<NavBar />
			<Switch>
				<Route exact path="/" component={Home} />
				<Route path="/software" component={AppBox} />
				<Route path="/education" component={Education} />
				<Route path="/publications" component={Publications}/>
				<Route path="/news" exact component={News} />
				<Route path="/news/upload" component={EventUpload} />
				<Route path="/jobs/application" component={JobApplication} />
				<Route path="/jobs" component={Jobs} />
				<Route path="/covid-19/faqs" component={COVIDA} />
				<Route path="/covid-19/answer/:_id" component={COVIDAnswer} />
				<Route path="/covid-19/ask-question" component={COVIDQ} />
				<Route path="/covid-19" component={COVID} />
				<Route path="/about" exact component={About} />
				<Route path="/about/alumni" component={Alumni} />
				<Route path="/events" component={Events} />
				<Route path="/user/login" component={Login} />
				<Route path="/user/signup" component={SignUp} />
				{redirects.map(({ from, to }) => (
					<Redirect from={from} to={to} />
				))}
				<Redirect to="/" />
			</Switch>
		</React.Fragment>
	);
}
function App() {
	return (
		<React.Fragment>
			<Router>
				<div className="content">
					<Routes />
				</div>
				<Footer />
			</Router>
		</React.Fragment>
	);
}

export default App;
